"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonSpaces = void 0;
var MoonSpaces;
(function (MoonSpaces) {
    MoonSpaces["LUNA_TRADE_STATION"] = "m01";
    MoonSpaces["MARE_IMBRIUM"] = "m07";
    MoonSpaces["MARE_SERENITATIS"] = "m14";
    MoonSpaces["MARE_NUBIUM"] = "m24";
    MoonSpaces["MARE_NECTARIS"] = "m26";
    MoonSpaces["MOMENTUM_VIRIUM"] = "m37";
})(MoonSpaces = exports.MoonSpaces || (exports.MoonSpaces = {}));
//# sourceMappingURL=MoonSpaces.js.map